import { useNavigate, useSearchParams } from "react-router-dom"
import ExtraInfo from "../components/extraInfo"

export default function OnlineEligibility() {
	const [searchParams] = useSearchParams()
	const navigate = useNavigate()

	function checkSelectionsToDisableContinue() {
		let stops = [
			"manufacturedMobileYes",
			"ownershipTypeOther",
			"citizenshipNo",
			"outOfStateResidencyYes",
			"confidentialityYes"
		]

		let disabled = false

		stops.forEach((id) => {
			if (document.getElementById(id) && document.getElementById(id).checked) {
				document.getElementById("continueButton").disabled = "true"
				disabled = true
			}
		})

		if (!disabled) {
			document.getElementById("continueButton").disabled = ""
		}
	}

	function stopProcessPopup() {
		alert("You will not be able to continue with the online exemptions application process. Please call us for more information at (850) 983-1880")
		checkSelectionsToDisableContinue()
	}

	function redirectToRegister(event) {
		event.preventDefault()
		navigate("/register")
	}

	return (
		<form
			id="exemptions-portal--eligibility"
			onSubmit={redirectToRegister}
			className="container"
		>
			<h1 className="h1-style">Online Eligibility Check</h1>
			<div className="row">
				<div className="col-12">
					<div className="bg-navy text-light p-3 rounded">
						<div className="bg-navy-dark p-3 rounded mb-3">
							<h4 className="mb-3">
								Are you an individual who qualifies for confidentiality under Florida Statute
								{" "}
								<a
									target="_blank"
									rel="noreferrer noopener"
									href="https://www.flsenate.gov/laws/statutes/2021/119.071"
									className="text-warning"
								>
									119.071(4)(d)
								</a>
								{" "}
								and believe your records are blocked?
							</h4>
							<div className="d-flex gap-3">
								<div className="form-check">
									<input
										type="radio"
										id="confidentialityYes"
										name="confidentiality"
										onClick={stopProcessPopup}
										value="Yes"
										className="form-check-input"
									/>
									<label htmlFor="confidentialityYes" className="form-check-text">
										Yes
									</label>
								</div>
								<div className="form-check">
									<input
										type="radio"
										required
										id="confidentialityNo"
										name="confidentiality"
										onClick={checkSelectionsToDisableContinue}
										value="No"
										className="form-check-input"
									/>
									<label htmlFor="confidentialityNo" className="form-check-text">
										No
									</label>
								</div>
							</div>
						</div>
						{
							searchParams.get("promptForBuilding") !== null &&
							searchParams.get("promptForBuilding") === "true" &&
							<>
								<div className="bg-navy-dark p-3 rounded mb-3">
									<h4 className="mb-3">
										Is the primary residence on this parcel a manufactured or mobile home?
									</h4>
									<div className="d-flex gap-3">
										<div className="form-check">
											<input
												type="radio"
												required
												id="manufacturedMobileYes"
												name="manufacturedMobile"
												onClick={stopProcessPopup}
												value="true"
												className="form-check-input"
											/>
											<label htmlFor="manufacturedMobileYes" className="form-check-text">
												Yes
											</label>
										</div>
										<div className="form-check">
											<input
												type="radio"
												id="manufacturedMobileNo"
												name="manufacturedMobile"
												onClick={checkSelectionsToDisableContinue}
												value="false"
												className="form-check-input"
											/>
											<label htmlFor="manufacturedMobileNo" className="form-check-text">
												No
											</label>
										</div>
									</div>
								</div>
							</>
						}
						<div className="bg-navy-dark p-3 rounded mb-3">
							<h4 className="mb-3">
								Select which of the following best describes the owner or all owners of this parcel as designated by the deed:
							</h4>
							<div className="d-flex gap-3">
								<div className="form-check">
									<input
										type="radio"
										required
										id="ownershipTypeSingle"
										name="ownershipType"
										onClick={checkSelectionsToDisableContinue}
										value="Single"
										className="form-check-input"
									/>
									<label htmlFor="ownershipTypeSingle" className="form-check-text">
										One Sole Owner 
									</label>
									<ExtraInfo
										info="If you are the sole owner, but are married, please select Married Couple"
										id="Married"
									/>
								</div>
								<div className="form-check">
									<input
										type="radio"
										required
										id="ownershipTypeMarriedCouple"
										name="ownershipType"
										onClick={checkSelectionsToDisableContinue}
										value="MarriedCouple"
										className="form-check-input"
									/>
									<label
										htmlFor="ownershipTypeMarriedCouple"
										className="form-check-text"
									>
										One Married Couple
									</label>
								</div>
								<div className="form-check">
									<input
										type="radio"
										id="ownershipTypeOther"
										name="ownershipType"
										onClick={stopProcessPopup}
										value="Other"
										className="form-check-input"
									/>
									<label htmlFor="ownershipTypeOther" className="form-check-text">
										Other
									</label>
								</div>
							</div>
						</div>
						<div className="bg-navy-dark p-3 rounded mb-3">
							<h4 className="mb-3">
								Are all owners of the parcel U.S. citizens?
							</h4>
							<div className="d-flex gap-3">
								<div className="form-check">
									<input
										type="radio"
										required
										id="citizenshipYes"
										name="allCitizens"
										onClick={checkSelectionsToDisableContinue}
										value="true"
										className="form-check-input"
									/>
									<label htmlFor="citizenshipYes" className="form-check-text">
										Yes
									</label>
								</div>
								<div className="form-check">
									<input
										type="radio"
										id="citizenshipNo"
										name="allCitizens"
										onClick={stopProcessPopup}
										value="false"
										className="form-check-input"
									/>
									<label htmlFor="citizenshipNo" className="form-check-text">
										No
									</label>
								</div>
							</div>
						</div>
						<div className="bg-navy-dark p-3 rounded mb-3">
							<h4 className="mb-3">
								Do any owners of this parcel claim residency in another state?
							</h4>
							<div className="d-flex gap-3">
								<div className="form-check">
									<input
										type="radio"
										required
										id="outOfStateResidencyYes"
										name="outOfStateResidency"
										onClick={stopProcessPopup}
										value="true"
										className="form-check-input"
									/>
									<label htmlFor="outOfStateResidencyYes" className="form-check-text">
										Yes
									</label>
								</div>
								<div className="form-check">
									<input
										type="radio"
										id="outOfStateResidencyNo"
										name="outOfStateResidency"
										onClick={checkSelectionsToDisableContinue}
										value="false"
										className="form-check-input"
									/>
									<label htmlFor="outOfStateResidencyNo" className="form-check-text">
										No
									</label>
								</div>
							</div>
						</div>
						<input
							type="submit"
							id="continueButton"
							value="Continue"
							className="btn btn-warning"
						/>
					</div>
				</div>
			</div>
		</form>
	)
}